<template>
  <div id="dashboard" class="content">
    <div class="row">
      <div class="col-md-6 col-xl-4">
        <a class="block text-center cursor-auto" href="javascript:void(0)">
          <div class="block-content block-content-full">
            <div class="font-size-h1 font-w300 text-black mb-1">{{ hearderData.NUM ||0}}</div>
            <a class="link-fx font-size-sm text-uppercase text-muted" href="javascript:void(0)">退办记录</a>
          </div>
        </a>
      </div>
      <div class="col-md-6 col-xl-4">
        <a class="block text-center cursor-auto" href="javascript:void(0)">
          <div class="block-content block-content-full">
            <div
              class="font-size-h1 font-w300 text-success mb-1"
            >{{changeTwoDecimal(hearderData.TOTAL_FEE||0)}}</div>
            <a
              class="link-fx font-size-sm text-uppercase text-muted"
              href="javascript:void(0)"
            >累计退款金额(元)</a>
          </div>
        </a>
      </div>
      <div class="col-md-6 col-xl-4">
        <a class="block text-center cursor-auto" href="javascript:void(0)">
          <div class="block-content block-content-full">
            <div class="font-size-h1 font-w300 text-warning mb-1">{{ hearderData.PACKAGE ||0}}</div>
            <a
              class="link-fx font-size-sm text-uppercase text-muted"
              href="javascript:void(0)"
            >累计退还时长(分钟)</a>
          </div>
        </a>
      </div>
    </div>

    <div class="col-12" style="margin-bottom: 10px;">
      <div class="row mb-2 mt-4" style="margin-right: -64px;">
        <div class="col-6 row">
          <h2 class="h3 font-w400 mb-0 line-height">订单退办记录</h2>
        </div>
        <div class="col-6 text-right mr-0">
          <screenTime :isToday="'0'" :isBlack="true" @changePage="changePage"></screenTime>
        </div>
      </div>
    </div>

    <div class="block block-rounded block-bordered">
      <div class="block-header block-header-default">
        <h3 class="block-title">{{ '时间范围： ' + duration.startDate + ' 至 ' + this.duration.endDate }}</h3>
        <div class="block-options">
          <!-- <button
            v-if="addBtn"
            type="button"
            class="btn-block-option add-btn mr-2"
            data-toggle="modal"
            @click="create()"
          >
            <i class="fa fa-plus mr-1"></i> 申请提现
          </button>-->
          <button
            type="button"
            class="btn-block-option"
            data-toggle="block-option"
            data-action="fullscreen_toggle"
          >
            <i class="si si-size-fullscreen"></i>
          </button>
        </div>
      </div>
      <div class="block-content block-content-full">
        <div class="dataTables_wrapper dt-bootstrap4 no-footer">
          <div class="row mb-1">
            <div class="col-12 col-md-4 text-center text-md-left">
              <pageSize @changePageSize="changePageSize"></pageSize>
            </div>
            <div class="col-12 col-md-4 text-center text-md-center" v-show="!isMobile">
              <div class="dt-buttons">
                <button
                  class="dt-button buttons-copy buttons-html5 btn btn-sm btn-primary mr-2 pding-btn"
                  tabindex="0"
                  aria-controls="DataTables_Table_1"
                  data-clipboard-text
                  @click="copy()"
                  type="button"
                  id="copybtn"
                >
                  <span>复制</span>
                </button>
                <button
                  class="dt-button buttons-csv buttons-html5 btn btn-sm btn-primary mr-2 pding-btn"
                  @click="exportCSV()"
                  type="button"
                >
                  <span>导出</span>
                </button>
                <button
                  class="dt-button buttons-print btn btn-sm btn-primary mr-2 pding-btn"
                  @click="print()"
                >
                  <span>打印</span>
                </button>
              </div>
            </div>
            <div class="col-sm-12 col-md-4 text-right">
              <div class="dataTables_filter">
                <!-- <select
                    class="form-control  inline-block col-1 mr-3"
                    id="device-state"
                    name="device-state"
                    v-model="state"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in meterStatus"
                      :key="index"
                      :value="item.value"
                    >{{item.label}}</option>
                </select>-->
                <label>
                  <input
                    type="search"
                    class="form-control"
                    placeholder="搜索"
                    v-model="key"
                    @keyup.enter="search()"
                  />
                </label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="table-responsive">
                <section ref="print">
                  <p class="show-on-print print-title">订单退办记录</p>
                  <p
                    class="show-on-print print-subheading"
                  >{{ '时间范围： ' + duration.startDate + ' 至 ' + this.duration.endDate }}</p>
                  <table
                    class="table table-bordered table-striped table-vcenter js-dataTable-full dataTable no-footer"
                  >
                    <thead>
                      <tr>
                        <th
                          class="text-center sorting"
                          style="width: 60px; min-width:60px"
                          @click="getList('CREATE_TIME',$event)"
                        >#</th>
                        <th
                          class="text-left sorting"
                          style="min-width:140px;"
                          @click="getList('REFUND_ORDER_NO',$event)"
                        >退款单号</th>
                        <th
                          class="text-left sorting"
                          style="min-width:140px;"
                          @click="getList('ORDER_NO',$event)"
                        >订单号</th>
                        <th
                          class="text-left d-md-table-cell sorting"
                          style="min-width:125px;"
                          @click="getList('USER_ID',$event)"
                        >用户ID</th>
                        <!-- <th
                          class="text-left d-md-table-cell sorting"
                          style="min-width:125px;"
                          @click="getList('USER_ID',$event)"
                        >手机号</th> -->
                        <th
                          class="text-left d-md-table-cell sorting"
                          style="min-width:95px;"
                          @click="getList('TYPE',$event)"
                        >退办类型</th>
                        <th
                          class="text-left d-md-table-cell sorting"
                          style="min-width:100px;"
                          @click="getList('PAY_WAY',$event)"
                        >退办方式</th>
                        <th
                          class="text-left d-md-table-cell sorting"
                          style="min-width:120px;"
                          @click="getList('REFUND_FEE',$event)"
                        >退还金额(元)</th>
                        <th
                          class="text-left d-md-table-cell sorting"
                          style="min-width:135px;"
                          @click="getList('PACKAGE',$event)"
                        >退还时长</th>
                        <th
                          class="text-left sorting"
                          style="min-width:110px;"
                          @click="getList('CREATE_TIME',$event)"
                        >办理时间</th>
                        <th
                          class="text-left d-md-table-cell sorting"
                          style="min-width:100px;"
                          @click="getList('REFUND_TYPE',$event)"
                        >办理人</th>
                        <!-- <th
                          class="text-center d-xl-table-cell sorting"
                          style="min-width:100px;"
                          @click="getList('STATE',$event)"
                        >办理状态</th>-->
                      </tr>
                    </thead>
                    <tbody v-if="meters.length">
                      <tr v-for="(item, i) in meters" :key="i">
                        <td class="text-center">{{ i + 1 }}</td>
                        <td class="text-left">
                          <div class="text-over" style="width:130px">{{ item.REFUND_ORDER_NO }}</div>
                        </td>
                        <td class="text-left">
                          <div class="text-over" style="width:130px">{{ item.ORDER_NO }}</div>
                        </td>
                        <td class="text-left d-md-table-cell">{{ item.USER_ID}}</td>
                        <!-- <td class="text-left d-md-table-cell">{{ item.USER_ID}}</td> -->
                        <td class="text-left d-md-table-cell">{{ showType(item.TYPE)}}</td>
                        <td class="text-left d-md-table-cell">{{ showPayType(item.PAY_WAY)}}</td>
                        <td class="text-left d-md-table-cell">{{ changeTwoDecimal(item.REFUND_FEE)}}</td>
                        <td class="text-left d-md-table-cell">{{ item.PACKAGE}}</td>
                        <td class="text-left">{{ formatTimeG(item.CREATE_TIME) }}</td>
                        <td class="text-left d-md-table-cell">{{item.REFUND_TYPE}}</td>
                        <!-- <td class="text-center d-xl-table-cell" style="min-width:80px;">
                          <span
                            class="badge badge-pill badge-success"
                            :class="{'badge-secondary':item.STATE=='1','badge-warning':item.STATE=='0'}"
                          >{{showState(item.STATE)}}</span>
                        </td>-->
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr>
                        <td class="text-center" colspan="11">查无数据</td>
                      </tr>
                    </tbody>
                  </table>
                </section>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-5 text-center text-md-left" v-show="!isMobile">
              <div class="dataTables_info" role="status" aria-live="polite">
                页数
                <strong>{{ page }}</strong> /
                <strong>{{ totalPage }}</strong>
              </div>
            </div>
            <div class="col-sm-12 col-md-7 text-center text-md-right">
              <div class="dataTables_paginate paging_full_numbers">
                <el-pagination
                  v-if="meters && meters.length"
                  @current-change="handleCurrentChange"
                  :current-page="page"
                  :page-size="pageSize"
                  :small="isMobile"
                  :pager-count="pagerCount"
                  :layout="isMobile ? 'prev, pager, next':'total, prev, pager, next'"
                  :total="total"
                  background
                ></el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Util from "../../../Util.js";
import screenTime from "../../../components/screenTime";
import pageSize from "../../../components/pageSize";
export default {
  name: "index",
  data() {
    return {
      meters: [],
      entry: {},
      setToday: new Date(),
      starttime: "",
      endtime: "",
      key: "",
      page: 1,
      size: 10,
      total: 1,
      pageSize: 20,
      selects: [10, 20, 30, 50],
      created: false,
      provinceList: [],
      cityList: [],
      districtList: [],
      cellList: [],
      pro: "",
      city: "",
      dis: "",
      cellName: "",
      sorting: "",
      orderBy: false,
      payMoney: "",
      fee: "",
      withDram: "",
      hearderData: {},
      addBtn: Util.isHavePerm("reflect/apply")
    };
  },
  components: {
    screenTime,
    pageSize
  },
  computed: {
    duration() {
      return this.$store.state.duration;
    },
    roleName() {
      return this.$store.state.roleName;
    },
    totalPage() {
      if (this.total == 0) {
        return 0;
      } else {
        return Math.ceil(this.total / this.pageSize, 1);
      }
    },
    pagerCount() {
      return this.$store.state.pagerCount;
    },
    isMobile() {
      return this.$store.state.isMobile;
    },
    regionParams() {
      return this.$store.state.regionParams;
    }
  },
  watch: {
    "$store.state.duration": {
      handler: function(val, oldVal) {
        if (typeof oldVal === "undefined") return;
        if (JSON.stringify(val) != JSON.stringify(oldVal)) {
          this.getList();
          this.getHearderData();
        }
      },
      immediate: true,
      deep: true
    },

    key(val, oldVal) {
      if (val.length == 0) {
        this.getList();
        this.getHearderData();
      }
    }
  },
  mounted() {
    this.getList();
    this.getHearderData();
    this.copy();
  },
  methods: {
    changePageSize(val) {
      this.pageSize = val;
      this.page = 1;
    },
    changePage(val) {
      this.page = val;
    },
    formatTimeG(val) {
      return Util.formatTimeG(val);
    },
    getHearderData() {
      this.$http
        .get(
          `${Util.searchURL}/Carport/GetRefundInfo/${this.duration.startDate}/${this.duration.endDate}`
        )
        .then(result => {
          this.hearderData = result.data.data;
        });
    },
    getList(sorting, that) {
      let params = {};
      if (this.key.length > 0) {
        params["key"] = this.key.trim();
      }
      if (sorting != undefined || this.sorting.length > 0) {
        this.sorting = sorting == undefined ? this.sorting : sorting;
        params["sort"] = this.sorting;
        params["orderBy"] = this.orderBy;

        if (that != undefined && that.currentTarget != undefined) {
          var obj = that.currentTarget;
          if (
            $(obj).is(".sorting_asc") ||
            $(obj).is(".sorting_desc") ||
            $(obj).is(".sorting")
          ) {
            $(obj)
              .parent("tr")
              .children("th")
              .removeClass("sorting_asc");
            $(obj)
              .parent("tr")
              .children("th")
              .removeClass("sorting_desc");
            $(obj).addClass(this.orderBy ? "sorting_asc" : "sorting_desc");
            this.orderBy = !this.orderBy;
            params["orderBy"] = this.orderBy;
          }
        }
      }
      this.$http
        .get(
          `${Util.searchURL}/Carport/ListByRefund/${this.duration.startDate}/${this.duration.endDate}/${this.page}/${this.pageSize}?region=${this.regionParams.region}&object=${this.regionParams.object}`,

          {
            params: params
          }
        )
        .then(res => {
          if (res.data.code === 200) {
            this.meters = res.data.data.data;
            this.total = res.data.data.pageInfo.total;
          }
        });
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    showRefundType(str) {
      switch (str) {
        case "0":
          return "退还余额";
        case "1":
          return "原支付返还";
      }
    },
    showType(str) {
      switch (str) {
        case "1":
          return "退款";
        case "2":
          return "退时长";
      }
    },
    showPayType(str) {
      switch (str) {
        case "0":
          return "退还余额";
        default:
          return "原支付返还";
        // case "0":
        //   return "余额";
        // case "1":
        //   return "微信";
        // case "2":
        //   return "支付宝";
        // case "3":
        //   return "杉德";
        // case "4":
        //   return "农行";
      }
    },
    showState(str) {
      switch (str) {
        case "0":
          return "处理中";
        case "1":
          return "已办结";
      }
    },
    changeTwoDecimal(val) {
      return Util.changeTwoDecimal(val);
    },
    search() {
      this.page = 1;
      this.getList();
    },
    exportCSV() {
      let params = {};
      if (this.key) {
        params["key"] = this.key.trim();
      }
      // params['key'] =  ''
      params["down"] = 1;
      params["sort"] = this.sorting;
      params["orderBy"] = this.orderBy;
      this.$http
        .get(
          `${Util.searchURL}/Carport/ListByRefund/${this.duration.startDate}/${this.duration.endDate}/${this.page}/${this.pageSize}?region=${this.regionParams.region}&object=${this.regionParams.object}`,
          {
            params: params,
            responseType: "blob"
          }
        )
        .then(res => {
          if (res.status === 200) {
            Util.ExportCSV(res);
          }
        });
    },
    print() {
      this.$print(this.$refs.print);
    },
    copy() {
      let copyStr = document.getElementsByTagName("section")[0].innerText;
      var btn = document.getElementById("copybtn");
      btn.setAttribute("data-clipboard-text", copyStr);
      this.clipboard = new ClipboardJS(btn);
      this.clipboard.on("success", e => {
        Util.message("succ", "复制成功");
        this.clipboard.destroy();
        e.clearSelection();
      });
    }
  }
};
</script>